module.exports = __webpack_public_path__ + "static/media/location-outlined.9414ef1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location-outlined.svg
// module id = 2241
// module chunks = 0